import React from 'react';
import { Tab as TabSui, TabProps } from 'semantic-ui-react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const ColoredTab = ({ ...rest }:TabProps) => {
	const backgroundColor = useSelector(state => state.ui.customer.primaryColor);

	return <StyledTab backgroundColor={backgroundColor} { ...rest } />;
};

const MiddleManTab = ({ backgroundColor, ...rest }:MiddleManTabProps) => {
	return <TabSui { ...rest } />;
};

const StyledTab = styled(MiddleManTab)`
	${(p:MiddleManTabProps) => `
		&&& > .tabular.menu > .item.active {
			background-color: ${p.backgroundColor};
			color: #ffffff;
		}

		&&& > .tab.active {
			border-top: solid ${p.backgroundColor} !important;
		}
	`}`;

interface MiddleManTabProps extends TabProps {
	backgroundColor:string
}

export default ColoredTab;